const CategoriesMixins = {
    data() {
        return {
            categories: [
                {
                    title: 'Моды Assetto Corsa',
                    links: [
                        {
                            title: 'Дорожные авто',
                            obj: {
                                name: 'mods',
                                params: { game: 'assetto-corsa' },
                                query: { category: 'cars', page: 1 }
                            }
                        },
                        {
                            title: 'Гоночные авто',
                            obj: {
                                name: 'mods',
                                params: { game: 'assetto-corsa' },
                                query: { category: 'sportcars', page: 1 }
                            }
                        },
                        {
                            title: 'Карты',
                            obj: {
                                name: 'mods',
                                params: { game: 'assetto-corsa' },
                                query: { category: 'maps', page: 1 }
                            }
                        }
                    ]
                },
                {
                    title: 'Моды BeamNG.Drive',
                    links: [
                        {
                            title: 'Легковые авто',
                            obj: {
                                name: 'mods',
                                params: {
                                    game: 'beamng-drive'
                                },
                                query: {
                                    category: 'cars',
                                    page: 1
                                }
                            }
                        },
                        {
                            title: 'Грузовики и пикапы',
                            obj: {
                                name: 'mods',
                                params: {
                                    game: 'beamng-drive'
                                },
                                query: {
                                    category: 'trucks',
                                    page: 1
                                }
                            }
                        },
                        {
                            title: 'Кроссоверы',
                            obj: {
                                name: 'mods',
                                params: {
                                    game: 'beamng-drive'
                                },
                                query: {
                                    category: 'suvs',
                                    page: 1
                                }
                            }
                        },
                        {
                            title: 'Автобусы',
                            obj: {
                                name: 'mods',
                                params: {
                                    game: 'beamng-drive'
                                },
                                query: {
                                    category: 'buses',
                                    page: 1
                                }
                            }
                        },
                        {
                            title: 'Карты',
                            obj: {
                                name: 'mods',
                                params: {
                                    game: 'beamng-drive'
                                },
                                query: {
                                    category: 'maps',
                                    page: 1
                                }
                            }
                        }
                    ]
                },
            ]
        }
    }
}

export default CategoriesMixins